module.exports = __webpack_public_path__ + "fonts/Prompt-Black.e62b3130.ttf";